import { usePage } from "@inertiajs/react";
import { useEffect } from "react";
import { loadPostHog } from "@/lib/posthog";

/**
 * Identifies the current user and organization in PostHog.
 * Call this once in the DashboardLayout.
 */
export function usePostHogIdentify() {
  const { current_user, current_organization } = usePage().props as any;

  useEffect(() => {
    let cancelled = false;

    void loadPostHog().then((posthog) => {
      if (!posthog || cancelled || !current_user) return;

      posthog.identify(`user_${current_user.id}`, {
        name: current_user.name,
        phone: current_user.phone,
      });

      if (current_organization) {
        posthog.group("organization", current_organization.name, {
          name: current_organization.name,
          slug: current_organization.slug,
        });
      }
    });

    return () => {
      cancelled = true;
    };
  }, [current_user?.id, current_organization?.id]);
}
